import { PLATFORM_IOS_UA_MARKER, PlatformRuntime } from './constants'

export default function getPlatformFromUserAgent(userAgent: string): PlatformRuntime {
  if (userAgent.includes(PLATFORM_IOS_UA_MARKER)) {
    return PlatformRuntime.ios
  }

  return PlatformRuntime.web
}
